import { FeatureLaunch, isFeatureLaunched } from '@commenda/feature-launches';
import { Button, Icons } from '@commenda/kakashi';

type SalesTaxTabId =
  | 'overview'
  | 'transactions'
  | 'products'
  | 'registrations'
  | 'returns';

interface TransactionsTabEmptyStateProps {
  onImportTransactions: () => void;
  onConnectIntegration: () => void;
}

const TransactionsTabEmptyState = ({
  onImportTransactions,
  onConnectIntegration,
}: TransactionsTabEmptyStateProps) => {
  const isRootfiIntegrationEnabled = isFeatureLaunched(
    FeatureLaunch.SALES_TAX_ROOTFI_INTEGRATION
  );

  return (
    <main className="flex flex-col min-h-[calc(100vh-401px)]">
      <div className="flex flex-col w-[640px] m-auto justify-center">
        <div className="flex items-start mt-5 flex-col gap-2">
          <h1 className="display-xs-bold">
            Import your transactions to start tracking sales tax
          </h1>
          <p className="txt-small-regular text-text-secondary">
            Include up to 2 years of historical sales data to accurately assess
            your compliance requirements.
          </p>
        </div>

        <div className="w-full flex items-center mt-8 gap-3">
          {isRootfiIntegrationEnabled && (
            <Button onClick={onConnectIntegration} size="md">
              <Icons.Link03 className="size-4" />
              <span>Connect integration</span>
            </Button>
          )}
          <Button size="md" variant="secondary" onClick={onImportTransactions}>
            <Icons.Upload01 className="size-4" />
            <span>Import transactions</span>
          </Button>
        </div>
      </div>
    </main>
  );
};

export default TransactionsTabEmptyState;
